import React, { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

interface PropTypes extends ComponentProps<"input"> {
  label?: string;
  error?: string;
  isInvalid?: boolean;
  containerClassName?: string;
}

const FileInput = ({
  label,
  error,
  className,
  isInvalid = false,
  containerClassName,
  ...rest
}: PropTypes) => {
  return (
    <div className={twMerge(containerClassName)}>
      {label ? (
        <div className="label">
          <span className="label-text text-[1rem] lg:text-xs">{label}</span>
        </div>
      ) : null}

      <input
        {...rest}
        type="file"
        className={twMerge(
          "input input-bordered w-full input-primary h-10 focus:border-none file-input file-input-primary p-0 file:font-normal",
          // ✅ Force button font size via inline style workaround class
          "[&::file-selector-button]:text-xs [&::file-selector-button]:text-white [&::file-selector-button]:h-full [&::file-selector-button]:px-3 [&::file-selector-button]:text-[11px]",
          "text-xs", // ✅ filename text size
          className
        )}
      />
      {isInvalid ? (
        <div className="label">
          <span className="label-text-alt text-red-600">{error}</span>
        </div>
      ) : null}
    </div>
  );
};

export default FileInput;
